import { render, staticRenderFns } from "./OzDropdownButton.vue?vue&type=template&id=0174d07e&"
import script from "./OzDropdownButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzDropdownButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports